import { AgreementsAPI } from '../api'
import { AgreementCreateAttachmentRequest } from '../types'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AGREEMENTS_QUERY_KEY } from './queryKey'

export const useCreateAttachment = (agreementId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (request: AgreementCreateAttachmentRequest) =>
      AgreementsAPI.createAttachment(agreementId, request),
    onSuccess: () => {
      queryClient.invalidateQueries([AGREEMENTS_QUERY_KEY.AGREEMENTS, agreementId])
    },
  })
}
